import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';

import { logout } from '../../store/reducers/user';
import { getCurrentUser } from '../../store/selectors/user';
import AppButton from './components/AppButton';
import AppMenu from './components/AppMenu';
import APP_MENU_ITEMS from '../../enums/AppMenuConfig';

const AppMenuContainer = ({
  handleOpen,
  onSelectMenuItem,
  handleSignOut,
  handleOnLoad,
}) => {
  const appMenuIconRef = useRef(null);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { photoURL, email, name } = useSelector(getCurrentUser);

  useEffect(() => {
    open && handleOnLoad && handleOnLoad();
  }, [handleOnLoad, open]);

  const handleOnClick = useCallback(() => {
    setOpen(!open);
    handleOpen && handleOpen();
  }, [handleOpen, open]);

  const onSingOut = useCallback(() => {
    dispatch(logout());
    handleSignOut && handleSignOut();
  }, [handleSignOut, dispatch]);

  return (
    <Box>
      <AppButton ref={appMenuIconRef} username={name} onClick={handleOnClick} />
      <AppMenu
        open={open}
        anchorEl={appMenuIconRef.current}
        photo={photoURL}
        email={email}
        username={name}
        setOpen={() => setOpen(false)}
        onSignOutClick={onSingOut}
        onSelectMenuItem={onSelectMenuItem}
        menuItems={APP_MENU_ITEMS}
      />
    </Box>
  );
};

export default memo(AppMenuContainer);
